import React from 'react';
import styled, { css } from 'styled-components';

import { useCardContext } from './card-context';

type CardBrandProps = {
  /** Override top margin (px). Defaults to 4. List card uses 6 on mobile. */
  marginTop?: number;
  /** Optional desktop override for margin-top (≥740px). When set, enables responsive margin. */
  desktopMarginTop?: number;
};

/** Brand name, truncated to 1 line. Renders a space when empty to preserve layout height. */
export function CardBrand({ marginTop = 4, desktopMarginTop }: CardBrandProps = {}): JSX.Element {
  const { brandName } = useCardContext();

  return (
    <Brand data-testid='card-brand' $marginTop={marginTop} $desktopMarginTop={desktopMarginTop}>
      {brandName || ' '}
    </Brand>
  );
}

const Brand = styled.div<{ $marginTop: number; $desktopMarginTop?: number }>`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: #646d72;
  display: -webkit-box;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  margin-top: ${({ $marginTop }) => $marginTop}px;
  overflow: hidden;

  ${({ $desktopMarginTop }) =>
    $desktopMarginTop != null &&
    css`
      @media screen and (min-width: 740px) {
        margin-top: ${$desktopMarginTop}px;
      }
    `}
`;
